/* eslint-disable no-restricted-syntax */
function getFieldFromSchemaByName(schema, name) {
  for (const field of schema) {
    if (field.name === name || field?.searchAs === name) {
      return field; // return the whole object
    }
    if (field.children && Array.isArray(field.children)) {
      const childField = getFieldFromSchemaByName(field.children, name);
      if (childField) {
        return childField;
      }
    }
  }
  return null; // not found
}

export default getFieldFromSchemaByName;
